import { ChangeDetectorRef, Component, ElementRef, Input, ViewChild } from '@angular/core'

const MIN_AMOUNT_RED_THRESHOLD = 33
export const STATUS_COLOR_GREEN = '#5FB85F'
export const STATUS_COLOR_RED = '#D9534F'
export const STATUS_COLOR_GRAY = '#E7E7E7'

@Component({
  selector: 'mb-mpup-amount-circle',
  templateUrl: './mpup-amount-circle.component.html',
  styleUrls: ['./mpup-amount-circle.component.scss']
})
export class MpupAmountCircleComponent {

  @ViewChild('container', { read: ElementRef, static: false })
  container!: ElementRef

  @Input()
  amount!: number

  @Input()
  maxAmount!: number

  fontSize!: string

  constructor (private changeDetector: ChangeDetectorRef) { }

  getColor (percentage: number): string {
    let color

    if(percentage > MIN_AMOUNT_RED_THRESHOLD) {
      color = STATUS_COLOR_GREEN
    } else if(percentage > 0 && percentage <= MIN_AMOUNT_RED_THRESHOLD) {
      color = STATUS_COLOR_RED
    } else {
      color = STATUS_COLOR_GRAY
    }

    return color
  }

  getStyle (): string {
    const percentage = (this.amount / this.maxAmount) * 100

    const r = 45 // radius of the circle
    const c = Math.PI * r * 2
    const offset = ((100 - percentage) / 100) * c

    return `stroke-dashoffset: ${offset}; stroke: ${this.getColor(percentage)}`
  }
}
